<div class="modal fade" tabindex="-1" [id]="'confirmationModal' + (id ? '-' + id : '')">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <i *ngIf="status !== 'success' && status !== 'warning'"
          class="bi bi-exclamation-triangle fs-1 text-danger mb-2"></i>
        <i *ngIf="status === 'warning'" class="bi bi-exclamation-circle-fill fs-1 text-warning mb-2"></i>
        <i *ngIf="status === 'success'" class="bi bi-check-circle-fill fs-1 text-success mb-2"></i>
        <h4 class="modal-title fw-bold">{{ (head ? head : 'COMMON.WILL_BE_DELETED') | translate }}</h4>
        <h5 *ngIf="head5" class="modal-title">{{ head5 }}</h5>
      </div>
      <div class="modal-body text-center">
        <div *ngIf="extendedMessage" [innerHTML]="extendedMessage | translate" class="innerHTMLStyle"></div>
        <p *ngIf="message !== 'false'" [innerHTML]="(message ? message : 'COMMON.SURE_TO_CONTINUE') | translate:{x:(displayId ?? id)}">
        </p>
      </div>
      <div *ngIf="!hideFooter" class="modal-footer">
        <button *ngIf="!hideConfirm" type="button" class="btn btn-dark" data-bs-dismiss="modal"
          (click)="confirm.emit()">{{
          (confirmText ? confirmText : 'COMMON.CONFIRM') | translate
          }}</button>
        <button *ngIf="!cancelAction && !hideConfirm" type="button" class="btn btn-outline-secondary"
          data-bs-dismiss="modal">{{
          (cancelText ? cancelText : 'COMMON.CANCEL') | translate
          }}</button>
        <button *ngIf="!cancelAction && hideConfirm" type="button" class="btn btn-outline-secondary"
          data-bs-dismiss="modal" (click)="confirm.emit()">{{
          (cancelText ? cancelText : 'COMMON.CANCEL') | translate
          }}</button>
        <button *ngIf="cancelAction" type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal"
          (click)="cancel.emit(cancelAction)">{{
          (cancelText ? cancelText : 'COMMON.CANCEL') | translate
          }}</button>
      </div>
    </div>
  </div>
</div>